import { render, staticRenderFns } from "./Survey.Question.RankedChoice.vue?vue&type=template&id=4cca831c&scoped=true&"
import script from "./Survey.Question.RankedChoice.vue?vue&type=script&lang=js&"
export * from "./Survey.Question.RankedChoice.vue?vue&type=script&lang=js&"
import style0 from "./Survey.Question.RankedChoice.vue?vue&type=style&index=0&id=4cca831c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca831c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VCol,VSelect})
